import React from "react";
import {Route, Switch} from "react-router-dom";
import Slider from "./slider/index";
import contactUs from "./contactUs/index";
import ProtectedRoute from "../../components/ProtectedRoute";

const WebsiteData = ({match}) => (
  <Switch>
    <ProtectedRoute path={`${match.url}/sliders`} component={Slider}/>
    <ProtectedRoute path={`${match.url}/contactUs`} component={contactUs}/>
  </Switch>
);

export default WebsiteData;
